import React, { useState, useEffect } from "react";
import Board from "./board";
import Panel from "./panel";
import Player from "./player";
import Update from "./update";
import Wheel from "./wheel";
import './styles/frame.css';
// import Wheeling from "./wheeling";
// import Round from "./round";


function Frame({playerA,playerB, playerC,pID , mwa,mwb,mwc,whatRound}) {

	useEffect(()=>{
		document.title="Wheel Of Fortune"
	})
	// console.log("in frame")
	

	/**
	 * handles all the players and update turns
	 */
	function handleTurns(){
		// should be called in the begining to set the initial player. 
	}

	/**
	 * handles all the wallets and updates them
	 */
	function handleWallets(){
		// update the main main wallet after each round
	}

	/**
	 * User makes a choice
	 */
	function handlePlayerChoice(playerChoice){
		// lock panel

		// when the user clicks a button this methos will be called. instead of (PANEL TO FRAME)
		// read choice passed from panel
		// set a value to usestate of the choice made
		// set boolean choice is made to true. 

		// then the controller will read if a choice is made it will lock the panel, and unlock the text area.
		
	}

	/**
	 * User enters a guess
	 */
	function handlePlayerInput(){
		// if usestate is C call consonant and pass guess or vowel or solve and pass user input
		// step one: take one letter only
		// step two: lock the text box
	}

	function validatePlayerInput(guess){
		// if length is one compare with the list
		// if length is more than one compare whole sentence
		// return true or false
	}
	
	/**
	 * User spins the wheel
	 */
	function handlePlayerWheelSpin(){
		// setstate
		// if value is money call money
		// else call bankrput
		// else call lose turn

	}

	/**
	 * player Choses to guess a consonant
	 * @param {*} guess 
	 */
	 function handleConsonant(guess){
		// unlock wheel
		// call to validate 
		// if return true
		// then call handleC wrong
		// else call handleC correct
		// lock wheel

	}
	/**
	 * Wheel spin results in Monetary Amount
	 */
	function makeMoney(){
		// unlock text and store value returned from text box
		// step one: store money in a variable
		// step three: open text box
	}

	function handleWrongConsonant(){
		// step one: update sentence
		// step two: change valueFromWheel back to 0
		// step three: update player tag to next
		// step three +: update player wallet to next.
		// step four: unlcok panel (make eventhandler do it instead)
	}

	function handleCorrectConsonant(){
		// step one: show the letter on the board
		// step two: update sentence
		// step three: keep same player
		// step four: add the money multipled by instances count to wallet
		// step five: unlock the panel
		// allow the same player to play again.
	}

	/**
	 * Wheel spin results in Lose Turn
	 */
	 function loseTurn(){
		// step 1: change player 
		// step 2: change wallet
		// step 3: update sentence
		// step 4: update sentence
		// step 5: unlock the panel
	}

	/**
	 * Wheel spin results in Bankrupt
	 */
	function bankrupt(){
		// step 1: change player 
		// step 2: change wallet
		// step 3: update sentence
		// step 4: update sentence
		// step 5: unlock the panel
		// step 6: set current wallet to 0
	}

	/**
	 * player Choses to buy a vowel
	 * @param {*} guess 
	 */
	function handleVowel(guess){
		// unlock text
		// call validate 
		// if return true
		// then call handleV wrong
		// else call handleV correct
	}

	function canBuyVowel(){
		// step 1: lock panel
		// step 2: unlock text area
		// step 3: subtract money
	}

	function cannotBuyVowel(){
		// step 1: update sentence
		// step 2: unlock panel
	}

	function handleWrongVowel(){
		// step one: update sentence
		// step three: update player tag to next
		// step three +: update player wallet to next.
		// step four: unlcok panel
		// step five: lock text area
	}

	function handleCorrectVowel(){
		// step one: show the letter on the board
		// step two: update sentence
		// step three: keep same player
		// step four: unlock the panel
		// step five: allow the same player to play again.
	}

	/**
	 * player Choses to solve puzzle
	 * @param {*} guess 
	 */
	function handlesolve(guess){		
		// unlock text
		// call to validate 
		// if return true
		// then call handleS wrong
		// else call handleS correct
	}

	function handleWrongSolve(){
		// step one: change player and wallet
		// step two: unlock panel
	}

	function handleCorrectSolve(){
		// step one: display
		// step two: update main wallet 
		// step three: move to next round
	}

	// communication scenario 1 (guess consonant) ************************************************** DONE
		// step one: close option panel
		// step two: open wheel
			// scenario a: (wheel is money) ******************************************************** DONE
				// step one: store money in a variable
				// step two: lock wheel
				// step three: open text box
					// step one: take one letter only
					// step two: lock the text box
						
						//scenario a (good input) *************************************************** DONE
							// step one: show the letter on the board
							// step two: update sentence
							// step three: keep same player
							// step four: add the money multipled by instances count to wallet
							// step five: unlock the panel
							// allow the same player to play again.
						//scenario b (wrong input) ************************************************** DONE
							// step one: update sentence
							// step two: change valueFromWheel back to 0
							// step three: update player tag to next
							// step three +: update player wallet to next.
							// step four: umlcok panel
						
					
					
				
			// scenario b: (wheel is lose turn)  ************************************************* DONE
				// step 1: change player 
				// step 2: change wallet
				// step 3: update sentence
				// step 4: update sentence
				// step 5: unlock the panel

			// scenario c: (wheel is bankrput) ************************************************* DONE
				// step 1: change player 
				// step 2: change wallet
				// step 3: update sentence
				// step 4: update sentence
				// step 5: unlock the panel
				// step 6: set current wallet to 0

	// communication scenario 2 (buy Vowel) ********************************* DONE
		// subScenario a (has enough money) ********************************* DONE
			// step 1: lock panel
			// step 2: unlock text area
			// step 3: subtract money
				// scenario a (good guess) ********************************* DONE
					// step one: show the letter on the board
					// step two: update sentence
					// step three: keep same player
					// step four: unlock the panel
					// step five: allow the same player to play again.
				//scenario b (wrong input) ********************************* DONE
					// step one: update sentence
					// step three: update player tag to next
					// step three +: update player wallet to next.
					// step four: unlcok panel
					// step five: lock text area

		// subScenario b (no enough money) ********************************* DONE
			// step 1: update sentence
			// step 2: unlock panel


	// communication scenario 3 (solve Puzzle) ********************************* DONE
		// step 1: lock panel
		// step 2: unlock text area
			//subscenario a: (good guess) ********************************* DONE
				// step one: display
				// step two: update main wallet 
				// step three: move to next round
			//subscenario b: (bad guess) ********************************* DONE
				// step one: change player and wallet
				// step two: unlock panel



	const puzzles = ["The hills have eyes","Fast and Furious","Birds in your hand better that ten on the tree","better to arrive late than not to come at all", "bite the bullet","it is raining cats and dogs",
	"you only live once", "better safe than sorry","your guess is as good as mine",
	"birds of a feather flock together","bite off more than you can chew","by the skin of your teeth"];
	const consonants = ['b', 'c', 'd', 'f', 'g', 'h', 'j', 'k', 'l', 'm', 'n', 'p', 'q', 'r', 's', 't', 'v', 'w', 'x', 'y', 'z'];
	const vowels = ['a','e','i','o','u'];

	const max = 1
	const puzzleArray = [];


	const [myVowels,setMyVowels] = useState(vowels)
	const [myConsonants,setMyConsonants] = useState(consonants)

	const [guess , setGuess] = useState() // many dependencies
	const [inputDetected, setInputDetected] = useState(false);
	const [getRound,setRound] = useState(1);
	const [isLockWheel,setIsLockWheel] = useState(true);
	const [choice , setChoice] = useState();
	
	const [update, setUpdate] = useState('')
	const [showSolve,setshowSolve] = useState('one');
	const [dis , setDis] = useState(false);
	const [choiceDetected, setChoiceDetected] = useState(false);
	const [hasGuessed,setHasGuessed] = useState(false);  // many dependencies
	const [updateMsg, setUpdateMsg] = useState('Please select one of the options on the right!');

	const [puzzleID,setpuzzleID] = useState(); // many dependencies
	const [puzzle, setPuzzle] = useState(); // many dependencies
	const [puzzleSlices, setPuzzleSlices] = useState([]);
	const [counts , setCounts] = useState() // many dependencies
	const [isTrue,setIsTrue] = useState(); // many dependencies
	const [myVal,setMyVal]= useState(); // many dependencies
	const [spun,setSpun] = useState(false);
	const [valueFromWheel, setValueFromWheel] = useState(); // many dependencies
	
	const [whoIsPlaying, setWhoIsPlaying] = useState(); // many dependencies
	const [moneyA,setMoneyA] = useState(0);
	const [moneyB,setMoneyB] = useState(0);
	const [moneyC,setMoneyC] = useState(0);
	const [styleA,setStyleA] = useState("none");
	const [styleB,setStyleB] = useState("none");
	const [styleC,setStyleC] = useState("none");
	const [MainWalletA,setMainWalletA] = useState(mwa);
	const [MainWalletB,setMainWalletB] = useState(mwb);
	const [MainWalletC,setMainWalletC] = useState(mwc);	

	const [next,setNext] = useState(true); // next button disabling
	const [blink,setBlink] = useState(); // blinking effect
	const [getNext,setGetNext] = useState(false); // next round
	const [nextRound,setNextRound] = useState(); // round number
	const [firstId, setFirstId] = useState(); //
	const [buttonText,setButtonText]= useState('Next Round!');

	// console.log(puzzle)


	const panelToFrame = (childdata) => {
		setChoice(childdata);
		setChoiceDetected(!choiceDetected)
		setDis(true);
	}

	const updateToFrame = (childdata) => {

		if(choice === "C"){
			for(var i = 0; i < myConsonants.length; i++){
				if(childdata.toLowerCase() === myConsonants[i]){
					myConsonants.splice(i,1);
					// console.log(myConsonants)

					setGuess(childdata.toUpperCase());
					break;
				}else {
					setGuess('(Wrong input)');
				}
			}

		}else if(choice === "V"){
			

			for(var i = 0; i < myVowels.length; i++){
				if(childdata.toLowerCase() === myVowels[i]){
					myVowels.splice(i,1);

					// console.log(myVowels)

					setGuess(childdata.toUpperCase());
					
					
					break;
				}else {
					// console.log('wrong guess Vowel')

					setGuess('(Wrong input)');
				}
			}
			// console.log(childdata);

		}else if(choice === "S"){
			if(puzzle){
				if(childdata.toUpperCase() === puzzle){
					setGuess(childdata.toUpperCase());
					// console.log('true guess Solve')

				}else {
					// console.log('wrong guess Solve')
					

					setGuess('(Wrong input)');
				}
			}
		}
		

		// setGuess(childdata);

		// console.log("guess is: "+guess)
		// new try is working 
		setInputDetected(!inputDetected)
		// console.log("input detcted: "+!inputDetected)
	}

	const spinValue = (childdata) => {
		// console.log("From Wheel: "+childdata);
		setMyVal(childdata)
		setSpun(!spun);
		setUpdate("show");

	}

	function resetWallet(){
		localStorage.setItem('moneyA', "0");
    	localStorage.setItem('moneyB', "0");
    	localStorage.setItem('moneyC', "0");
	}


	const startButtonClick = ()=>{
		// console.log("someone clicked me!")
		setGetNext(!getNext);
	}

	useEffect(()=>{
		if(choice === "C"){
			// setIsLockWheel(false);
			localStorage.setItem('isWheelLocked', "0");

			setUpdateMsg('Now it is time to spin the wheel!')

			// setWheellocker(true);
			setshowSolve('small')
			// setUpdate("show");

			// check if letter entered is cons
			// else disregard
			// if compare.
		} else if (choice === "V"){
			setIsLockWheel(true);

			// console.log('in guess Vowel')
			if(whoIsPlaying === 'p1'){

				var tempWallet = parseInt(localStorage.getItem('moneyA'));
				if(tempWallet>=250){
					var tempSubtract = tempWallet - 250;
					localStorage.setItem('moneyA',tempSubtract);
					setMoneyA(tempSubtract);


					setUpdateMsg('it is time to enter your guess below!')
					setshowSolve('small')
					setUpdate("show");
					// setWheellocker(false);
				}else{
					setUpdateMsg("Sorry!... you don't have enough money to buy a vowel")
					setDis(false);
				}


			}else if(whoIsPlaying === 'p2'){

				var tempWallet = parseInt(localStorage.getItem('moneyB'));
				if(tempWallet>=250){
					var tempSubtract = tempWallet - 250;
					localStorage.setItem('moneyB',tempSubtract);
					setMoneyB(tempSubtract);


					setUpdateMsg('it is time to enter your guess below!')
					setshowSolve('small')
					setUpdate("show");
					// setWheellocker(false);		
				}else{
					setUpdateMsg("Sorry!... you don't have enough money to buy a vowel")
					setDis(false);
				}

				
			}else if(whoIsPlaying === 'p3'){

				var tempWallet = parseInt(localStorage.getItem('moneyC'));
				if(tempWallet>=250){
					var tempSubtract = tempWallet - 250;
					localStorage.setItem('moneyC',tempSubtract);
					setMoneyC(tempSubtract);


					setUpdateMsg('it is time to enter your guess below!')
					setshowSolve('small')
					setUpdate("show");
					// setWheellocker(false);
				}else{
					setUpdateMsg("Sorry!... you don't have enough money to buy a vowel")
					setDis(false);
				}
			}

			// setUpdateMsg('it is time to enter your guess below!')

			// setshowSolve('small')
			// setUpdate("show");
			// setWheellocker(false);
			// first check if the letter entered in a vowel
			// else disregard
			// if then compare


		} else if (choice === "S"){
			setIsLockWheel(true);
			setUpdateMsg('it is time to enter your guess below!')

			// console.log('is S')
			setshowSolve('large')
			setUpdate("show");
			// setWheellocker(false);
			// do not use normal comparison
			// if lengths match, compare else ignore.


		}
		
	},[choiceDetected])

	useEffect(() => {


		// console.log('in the first guess effect')
		setDis(false);
		
		// these are the sentences we need to update based on the player playing

		setUpdate("hide");
		// setTerminateturn(!terminateTurn)
		setHasGuessed(!hasGuessed);
		
		
		// i want this to depend on input detected
		

	// },[guess]);
	},[inputDetected]);

	useEffect(()=>{

		// console.log("isTrue: "+isTrue)
		if (!isTrue){
			// console.log('******bad guess?*******')
			// console.log(whoIsPlaying)


			if(whoIsPlaying === 'p1'){
				setUpdateMsg(playerA+' lost their turn, '+ playerB+ ' it is your turn now')

				// console.log("one")
				setWhoIsPlaying('p2');
				setStyleB('solid 5px lightgreen')
				setStyleA('none')
				setStyleC('none')
				
		
			} else if(whoIsPlaying === 'p2'){
				setUpdateMsg(playerB+' lost their turn, '+ playerC+ ' it is your turn now')

				setWhoIsPlaying('p3');
				setStyleC('solid 5px lightgreen')
				setStyleA('none')
				setStyleB('none')
	
			} else if(whoIsPlaying === 'p3'){
				setUpdateMsg(playerC+' lost their turn, '+ playerA+ ' it is your turn now')

				setWhoIsPlaying('p1');
				setStyleA('solid 5px lightgreen')
				setStyleB('none')
				setStyleC('none')
		
			}
			

			

		}else if(isTrue){

			// after S ?
		

			
			// console.log('>0')
			// console.log(whoIsPlaying)
			// console.log(valueFromWheel)
			// else{
			// 	setUpdateMsg('Please select on of the options!');
	
			// }

			// and wheel result is more than 0
			// multiply them and set them to a money variable
			// console.log(counts + " " + whoIsPlaying)
			// temp = (valueFromWheel * counts);
			// localStorage.setItem('moneyA', "0");
			// localStorage.setItem('moneyB', "0");
			// localStorage.setItem('moneyC', "0");

			if(whoIsPlaying === 'p1'){
				if(choice === "C"){

					var wheelWinnings = (valueFromWheel * counts);
					var previous = localStorage.getItem('moneyA');
					var current = wheelWinnings + parseInt(previous);
					localStorage.setItem('moneyA', current);


					setMoneyA(current);
					// set monye to the value from the storage
					//
					setUpdateMsg(playerA+', You earned $'+ wheelWinnings +' play again, make more!')

				} else if(choice === "V"){
					setUpdateMsg(playerA+', You made a correct guess play again!')


				}else if(choice === "S"){
					setUpdateMsg(playerA+' You have won the round check your bank!')
					var roundReward = 1500;
					var previous = localStorage.getItem('moneyA');
					var current = roundReward + parseInt(previous);
					localStorage.setItem('moneyA', current);
					setMoneyA(current);
					var currentTemp = localStorage.getItem('bankA');
					var addItUp = current + parseInt(currentTemp);
					localStorage.setItem('bankA', addItUp)
					var updateIT = localStorage.getItem('bankA');
					setMainWalletA(updateIT);
					// here when true we take older value and add it

					setRound(getRound+1);
					// setSolved(true);

					setMoneyA(0)
					setMoneyB(0)
					setMoneyC(0)
					setNext(false)
					setDis(true)
					setBlink('solid 5px greenyellow')

					

					resetWallet()
				}

				// if(!isNaN(valueFromWheel)){
					
				// 	setMoneyA(valueFromWheel * counts);
				// 	// console.log("money: "+moneyA)
				// }
				// setMoneyA(200 * counts);
				setStyleA('solid 5px lightgreen')
				setStyleB('none')
				setStyleC('none')
		
			} else if(whoIsPlaying === 'p2'){
				if(choice === "C"){

					var wheelWinnings = (valueFromWheel * counts);
					var previous = localStorage.getItem('moneyB');
					var current = wheelWinnings + parseInt(previous);
					localStorage.setItem('moneyB', current);


					setMoneyB(current);
					// set monye to the value from the storage
					//
					setUpdateMsg(playerB+', You earned $'+ wheelWinnings +' play again, make more!')

				} else if(choice === "V"){
					setUpdateMsg(playerB+', You made a correct guess play again!')


				}else if(choice === "S"){
					setUpdateMsg(playerB+' You have won the round check your bank!')
					var roundReward = 1500;
					var previous = localStorage.getItem('moneyB');
					var current = roundReward + parseInt(previous);
					localStorage.setItem('moneyB', current);
					setMoneyB(current); 
					var currentTemp = localStorage.getItem('bankB');
					var addItUp = current + parseInt(currentTemp);
					localStorage.setItem('bankB', addItUp)
					var updateIT = localStorage.getItem('bankB');
					setMainWalletB(updateIT);

					
					setRound(getRound+1);
					// setSolved(true);
					setMoneyA(0)
					setMoneyB(0)
					setMoneyC(0)
					setNext(false)
					setDis(true)
					setBlink('solid 5px greenyellow')

					// repeat we have two local storages
					// yep where do you suggest




					resetWallet()


				}
				// setMoneyB(valueFromWheel * counts);

				setStyleB('solid 5px greenyellow')
				setStyleA('none')
				setStyleC('none')


	
			} else if(whoIsPlaying === 'p3'){
				if(choice === "C"){

					var wheelWinnings = (valueFromWheel * counts);
					var previous = localStorage.getItem('moneyC');
					var current = wheelWinnings + parseInt(previous);
					localStorage.setItem('moneyC', current);


					setMoneyC(current);
					// set monye to the value from the storage
					//
					setUpdateMsg(playerC+', You earned $'+ wheelWinnings +' play again, make more!')

				} else if(choice === "V"){
					setUpdateMsg(playerC+', You made a correct guess play again!')


				}else if(choice === "S"){
					setUpdateMsg(playerC+' You have won the round check your bank!')

					var roundReward = 1500;
					var previous = localStorage.getItem('moneyC');
					var current = roundReward + parseInt(previous);
					localStorage.setItem('moneyC', current);
					setMoneyC(current);
					var currentTemp = localStorage.getItem('bankC');
					var addItUp = current + parseInt(currentTemp);
					localStorage.setItem('bankC', addItUp)
					var updateIT = localStorage.getItem('bankC');
					setMainWalletC(updateIT);

					setRound(getRound+1);
					// setSolved(true);
					setMoneyA(0)
					setMoneyB(0)
					setMoneyC(0)
					setNext(false)
					setDis(true)
					setBlink('solid 5px greenyellow')




					resetWallet()

				}
				// setMoneyC(valueFromWheel * counts);
				setStyleC('solid 5px greenyellow')
				setStyleB('none')
				setStyleA('none')

		
			}else {
				setWhoIsPlaying('p1')
				setStyleA('solid 5px lightgreen')
				setStyleB('none')
				setStyleC('none')
				
			}
			
			// the money variable will be determined by asking the 
			// jokers guy who is keeping track of the player

		}
		// console.log(whoIsPlaying)
		// console.log("Counts: "+counts)
		
	},[hasGuessed]);

	useEffect(()=>{
		// console.log(pID +" pid")
		 if(pID === puzzles.length-1){
            setpuzzleID(0)
        }else{
            setpuzzleID(pID+1)
        }
	},[pID])

	useEffect(()=>{
		
		var temporary = puzzles[puzzleID];
		// var temporary = localStorage.getItem('puzzle'+puzzleID);
		if(temporary){
			var temp = temporary.toUpperCase()
			setPuzzle(temp);
		}
		// console.log(puzzleID)
		// myPuzzles.splice(puzzleID,1);
		

		// setPuzzle(localStorage.getItem('puzzle'+puzzleID));
		// console.log("PUZZLE: "+puzzle)
	},[puzzleID])

	useEffect(()=>{
		if(puzzle){
			for(var i = 0; i < puzzle.length; i++){
				puzzleArray.push(puzzle?.charAt(i));
			}
			setPuzzleSlices(puzzleArray)
		}

	},[puzzle]);

	useEffect(()=>{
		var counting = 0

		// console.log("guess is " + guess)
		for(var i = 0 ; i <= puzzleSlices.length; i++){
			// var temp;
			// if(puzzleSlices){
			// 	temp = puzzleSlices[i].toLowerCase();
			// }
			if(guess === puzzleSlices[i]){
				setIsTrue(true);
				counting++;
			} else if (guess === puzzle){

				// console.log("TRUE *888888888888888**********")
				// console.log(puzzle+" in tru");
				setIsTrue(true);
				counting = 100;

				// then keep track of how many times
				
				// then pass letter to board.
			}
			if(counting === 0){
				setIsTrue(false);
			}
		}
		setCounts(counting);
		// setDis(false);

	// },[inputDetected]);
	},[guess]);
	
	useEffect(()=>{

		if(myVal == (-1)){
			setUpdate('hide')
			setDis(false)
			switch(whoIsPlaying) {
				case "p1":
				  // code block
				  	localStorage.setItem('moneyA',0)
					setMoneyA(0);
					setUpdateMsg(playerA+' lost their turn and money '+ playerB+ ' it is your turn now')

					setWhoIsPlaying('p2');
					setStyleB('solid 5px lightgreen')
					setStyleA('none')
					setStyleC('none')
				  break;
				case "p2":
					localStorage.setItem('moneyB',0)
					setMoneyB(0);
					setUpdateMsg(playerB+' lost their turn and money '+ playerC+ ' it is your turn now')

					setWhoIsPlaying('p3');
					setStyleC('solid 5px lightgreen')
					setStyleA('none')
					setStyleB('none')
				  // code block
				  break;
				case "p3":
					localStorage.setItem('moneyC',0)
					setMoneyC(0);
					setUpdateMsg(playerC+' lost their turn and money '+ playerA+ ' it is your turn now')

					setWhoIsPlaying('p1');
					setStyleA('solid 5px lightgreen')
					setStyleB('none')
					setStyleC('none')
				  // code block
				default:
					break;
			}
			  
			
		} 
		if(myVal == 0){
			setUpdate('hide')
			setDis(false)
			switch(whoIsPlaying) {
				case "p1":
				  // code block
				  	
					setUpdateMsg(playerA+' lost their turn '+ playerB+ ' it is your turn now')
					setWhoIsPlaying('p2');
					setStyleB('solid 5px lightgreen')
					setStyleA('none')
					setStyleC('none')
				  break;
				case "p2":
					
					setUpdateMsg(playerB+' lost their turn '+ playerC+ ' it is your turn now')
					setWhoIsPlaying('p3');
					setStyleC('solid 5px lightgreen')
					setStyleA('none')
					setStyleB('none')
				  // code block
				  break;
				case "p3":
					
					setUpdateMsg(playerC+' lost their turn '+ playerA+ ' it is your turn now')
					setWhoIsPlaying('p1');
					setStyleA('solid 5px lightgreen')
					setStyleB('none')
					setStyleC('none')
				  // code block
				default:
					break;
			}
			// set to next player
		}
	},[spun])

	useEffect(()=>{
		if(myVal > 0){
			// console.log("money "+ myVal)

			setUpdateMsg('it is time to enter your guess below!')

			setValueFromWheel(myVal);
		}

	},[spun])

	useEffect(()=>{
		if(whatRound <= 3){

			setNextRound(whatRound+1);
			setFirstId(whatRound)
		}  	else if(whatRound >= 4){
			
			
			
			window.location.reload();
			
		}
		if(whatRound === 3) {
		
			setGetNext(false)
			setButtonText('Play Again!');
			
			// here we wanna set the button text to 
			// new game 
			// then start over 
			// or quit? 
			// how do we refresh the page ?
			// location.reload()

		} 
		
	},[whatRound])	

    // console.log("ID "+puzzleID)

	return(

		<div className="container" >
			{/* <div style={{backgroundColor: 'white', color: 'black'}} >
				{myVal}
				{choice}
				{puzzle}
				{puzz}
				
			</div> */}

			<div className="rounds">
				Round  {whatRound}

			</div>

			<div className="player">
				{/* <div style={{backgroundColor: isBlurring}}>hhh</div> */}
				<div style={{border: styleA}} className="firstPlayer" ><Player playerName ={playerA} playerMoney ={moneyA} wheelspun = {spun} mianWallet={MainWalletA}/></div>
				<div style={{border: styleB}} className="secondPlayer"><Player playerName = {playerB} playerMoney ={moneyB} wheelspun = {spun} mianWallet={MainWalletB}/></div>
				<div style={{border: styleC}} className="thirdPlayer"><Player playerName ={playerC} playerMoney ={moneyC} wheelspun = {spun} mianWallet={MainWalletC}/></div>
			</div>

			{/* style={{animationName:'blinking'}} */}
			<div className="wheel" >
				<Wheel disableWheel={isLockWheel} spinValue={spinValue}/>
				{/* <Wheeling/> */}
			</div>

			<div className="update" >
				<Update id1={firstId} id2={firstId*2}  isSolve={showSolve} updateToFrame={updateToFrame} frameToUpdate={update} message={updateMsg} length={max}/>
			</div>

			<div className="panel" >
				<Panel toFrame={panelToFrame} frameToPanel = {dis}/>
			</div>

			<div className="nextRound">
				<button disabled={next} id='nxtRnd' onClick= {startButtonClick}>	
					<h1 style={{border: blink}} id="rndtxt">{buttonText}</h1>
				</button>
			</div>

			<div className="board">
				<Board guess={guess} puzzle={puzzle} puzzleID= {puzzleID} ></Board>
			</div>

			{getNext && <Frame whatRound= {nextRound} mwa={MainWalletA} mwb = {MainWalletB} mwc = {MainWalletC} playerA = {playerA} playerB = {playerB} playerC = {playerC} pID={puzzleID}/>}

		</div>

	)

}
export default Frame